// extracted by mini-css-extract-plugin
export default {"liked":"style_liked__iT1n2"};